/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Services_Missing_TitleInputs */

const en_services_missing_title = /** @type {(inputs: Services_Missing_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No such session`)
};

const pl_services_missing_title = /** @type {(inputs: Services_Missing_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nie ma takich zajęć`)
};

/**
* | output |
* | --- |
* | "No such session" |
*
* @param {Services_Missing_TitleInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const services_missing_title = /** @type {((inputs?: Services_Missing_TitleInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Services_Missing_TitleInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_services_missing_title(inputs)
	return en_services_missing_title(inputs)
});